import { locationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const emitWarehouseReturnSortedEvent = {
  name: "emitWarehouseReturnSortedEvent" as const,
  input: z.object({
    returnId: z.string().min(1),
    locationId: locationIdFormat.schema,
  }),
  output: z.object({}),
};
